import { useEffect, useState } from 'react';

const DISABLE_BY_SCROLL_TIMEOUT = 200;

/** Копипаста аналогичного хука из FiltersContainer, но без state, поскольку стейт лежит внутри микрофронта */
export function useTooltipDisabled(): boolean {
  const [isTooltipDisabledByScroll, setIsTooltipDisabledByScroll] = useState(false);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    const handleScroll = (): void => {
      setIsTooltipDisabledByScroll(true);
      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        clearTimeout(timeoutId);
        setIsTooltipDisabledByScroll(false);
      }, DISABLE_BY_SCROLL_TIMEOUT);
    };

    document.addEventListener('scroll', handleScroll, { passive: true });

    return (): void => {
      clearTimeout(timeoutId);
      document.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return isTooltipDisabledByScroll;
}
